import ShopItemsView from "../../components/shopItemsView/shopItemsView";

const FarmingOwnerItemView = () => {
    return (
        <div>
            <ShopItemsView update="/farming-item-update" deleteurl="/farming-profile" urlone="/farming-profile"/>
        </div>
    )
}
export default FarmingOwnerItemView;